function EqualHeight(className) {
  const elements = document.querySelectorAll("." + className);
  if (!elements.length) return;

  let maxHeight = 0;

  // reset heights
  elements.forEach(el => {
    el.style.height = "auto";
  });

  // get max height
  elements.forEach(el => {
    maxHeight = Math.max(maxHeight, el.offsetHeight);
  });

  // apply max height
  elements.forEach(el => {
    el.style.height = maxHeight + "px";
  });
}
 
 
document.addEventListener("DOMContentLoaded", function () {

  const dakshinJurnalSiwper = new Swiper(".dakshinJurnalSiwper", {
    loop: true,
    slidesPerView: 1.2,
    spaceBetween: 20,
    navigation: {
      nextEl: ".dakshin_jurnal_arrow_right",
      prevEl: ".dakshin_jurnal_arrow_left",
    },
    autoplay: { delay: 2000, disableOnInteraction: true },
    breakpoints: {
      600: { slidesPerView: 2, spaceBetween: 20 },
      800: { slidesPerView: 2.5 },
      1300: { slidesPerView: 3.2, spaceBetween: 40 },
    },
  });

  EqualHeight("dakshin_slide");
});

